import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { ClientRender } from '@change-corgi/core/react/ssr/render';
import { Separator } from '@change-corgi/design-system-legacy/components/content';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { useCurrentBreakpointValue } from '@change-corgi/design-system-legacy/responsive';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { SignFormContainer } from '../signForm';
import { SignatureStatsActiveContainer } from '../stats/signatureStats';

function SideUnsignedContainerInner(): JSX.Element {
	const desktop = useCurrentBreakpointValue([false, true]);

	return (
		<>
			<Heading as="h2" size="h4" mt={16} mb={16}>
				<Translate value="corgi.petition_gamma.petition_sign.sign_title" />
			</Heading>
			{desktop ? <SignFormContainer /> : <Loader size="s" mt={64} mx="auto" />}
		</>
	);
}

export function SideUnsignedContainer(): JSX.Element {
	return (
		<>
			<Box mb={16}>
				<SignatureStatsActiveContainer />
			</Box>
			<Separator />
			{/* using programmatic media query to allow lazy loading of the sign form in modal on mobile */}
			{/* Spinner is necessary for SSR */}
			<ClientRender placeholder={<Loader size="s" mt={64} mx="auto" />}>
				<SideUnsignedContainerInner />
			</ClientRender>
		</>
	);
}
